import { BackgroundColor } from "@silversea-ssc/ui-components-react";
import { CruisesSliderHitsProps } from "components/Algolia/CruisesSliderHits";
import FYCQueryBuilder from "components/FindYourCruise/FYCQueryBuilder";
import React, { PropsWithChildren } from "react";
import CruisesSlider from "components/CruisesSlider/CruisesSlider";

type Props = Pick<CruisesSliderHitsProps, "promosContent" | "shipsContent"> & {
  destinationWebCode: string | undefined;
  backgroundColor: BackgroundColor;
};

const FeaturedCruisesSlider: React.FC<PropsWithChildren<Props>> = ({
  destinationWebCode,
  backgroundColor,
  promosContent,
  shipsContent,
  children
}) => {
  const fycQuery = new FYCQueryBuilder()
    .filterByDestinationWebCode(destinationWebCode)
    .filterByLoadStress(["Good", "Average"])
    .onlyAvailableCruises()
    .generate();

  return (
    <CruisesSlider
      dataContentName="featured_cruises_slider"
      backgroundColor={backgroundColor}
      searchQuery={fycQuery}
      promosContent={promosContent}
      shipsContent={shipsContent}
      showDestination={false}
    >
      {children}
    </CruisesSlider>
  );
};

export default FeaturedCruisesSlider;
